import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json', // Default headers if any
    // Add any other headers you need here
  },
});

axiosInstance.interceptors.request.use(
  config => {
    //add token or any other request interceptors here
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Handle errors globally
    return Promise.reject(error);
  }
);

export default axiosInstance;
